export const GET_PERIODIC_MAINTENANCE_DATA = 'GET_PERIODIC_MAINTENANCE_DATA';
export const GET_PERIODIC_MAINTENANCE_SERVICES =
  'GET_PERIODIC_MAINTENANCE_SERVICES';
export const GET_PERIODIC_MAINTENANCE_ALL_SERVICES =
  'GET_PERIODIC_MAINTENANCE_ALL_SERVICES';
export const RESET_PERIODIC_MAINTENANCE = 'RESET_PERIODIC_MAINTENANCE';
